module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/tab/tab.component.scss
// module id = ./src/app/features/tabination/tab/tab.component.scss
// module chunks = main